import React from "react";
import "./styles.scss";

const DataExtractor = () => {
    return (
        <div className="data-extractor-main">
            <iframe
                src="/data-extractor.html"
                title="Data Extractor"
                className="data-extractor-frame"
            />
        </div>
    );
};

export default DataExtractor;
